import React, { Factory, useState } from "react";
import { AppLayout } from "../../templates";
import { Grid, TablePagination } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { factoryActions, shiftActions, alertActions, userActions, reportActions } from "../../_redux/actions";
import { authorizationService, operationMasterService, operatorMasterService } from "../../_services";
import { studyBrowserActions } from "../../_redux/actions";
import { DownloadStudyBrowserReport, OperationMasterDto, OperatorMasterDto, StudyBrowserListFiltersParamsDto } from "../../_models";
import {
    StudyBrowserDetail,
    AppPopup,
    StudyBrowserList,
    StudyBrowserFilters,
    PotentialStudyReport,
    YamazumiEbReport,
    YamazumiNebReport,
    AzureMediaPlayer,
    ProductionStudyReport,
    TimeStudyReport
} from "../../components";
import { utilFunctions } from "../../_helpers";
import { APP_CONFIGS, APP_EML_CATEGORY, APP_STUDIES, APP_STUDIES_LIST, APP_TABLE_SETTINGS, CHART_COLOR_PALETTE } from "../../_constants";
import StudyBrowserAatDetail from "../../components/study-browser/StudyBrowserAatDetail";
import { AddStudyOperationCommentPayloadDto, PlantDto, StudyBrowserFiltersDto, StudyRowCommentFormDataDto, UserDto } from "../../_models";
import { FactoryDto } from "../../_models/factory.models";
import TablePaginationActions from "@material-ui/core/TablePagination/TablePaginationActions";

const StudyBrowserPage = () => {
    const INITIAL_STATE = {
        studyDetailPopup: false,
        aatDetailPopup: false,
        videoPopup: false,
        videoPopupUrl: '',
        studyDetailPopupData: [],
        aatDetailPopupData: [],
        potentialReportPopup: false,
        potentialReportPopupData: {},
        yamazumiEbReportPopup: false,
        yamazumiEbReportPopupData: {},
        yamazumiNebReportPopup: false,
        yamazumiNebReportPopupData: {},
        productionReportPopup: false,
        productionReportPopupData: {},
        timeStudyReportPopup: false,
        timeStudyReportPopupData: {},
    }
    const INITIAL_FILTERS_STATE: StudyBrowserFiltersDto = {
        sbuId: { value: '', validator: 'text', isRequired: true, error: null, disabled: false },
        sbuCode: { value: '', validator: 'text', isRequired: true, error: null, disabled: false },
        plantId: { value: '', validator: 'text', isRequired: true, error: null, disabled: false },
        plantCode: { value: '', validator: 'text', isRequired: true, error: null, disabled: false },
        factoryId: { value: '', validator: 'text', isRequired: !authorizationService.getAuthorizedUser().isAdmin, error: null, disabled: false },
        factoryCode: { value: '', validator: 'text', isRequired: !authorizationService.getAuthorizedUser().isAdmin, error: null, disabled: false },
        userId: { value: '', validator: 'number', isRequired: false, error: null, disabled: false },
        userEmail: { value: '', validator: 'text', isRequired: false, error: null, disabled: false },
        studyId: { value: '', validator: 'number', isRequired: false, error: null, disabled: false },
        studyName: { value: '', validator: 'text', isRequired: false, error: null, disabled: false },
        module: { value: '', validator: 'text', isRequired: false, error: null, disabled: false },
        shiftCode: { value: '', validator: 'text', isRequired: false, error: null, disabled: false },
        style: { value: '', validator: 'text', isRequired: false, error: null, disabled: false },
        version: { value: '', validator: 'text', isRequired: false, error: null, disabled: false },
        isBestVideo: { value: false, validator: 'boolean', isRequired: false, error: null, disabled: false },
        gsdCode: { value: '', validator: 'text', isRequired: false, error: null, disabled: false },
        dateStart: { value: null, validator: 'text', isRequired: false, error: null, disabled: false },
        dateEnd: { value: null, validator: 'text', isRequired: false, error: null, disabled: false },
        operationMasterId: { value: null, validator: 'text', isRequired: false, error: null, disabled: false },
        operatorMasterId: { value: null, validator: 'text', isRequired: false, error: null, disabled: false },
    }
    const INITIAL_ROW_COMMENT: StudyRowCommentFormDataDto = {
        comment: { value: '', validator: 'text', isRequired: true, disabled: false, error: null }
    }

    const dispatch = useDispatch();
    const [studyBrowserPageState, setStudyBrowserPageState] = useState(INITIAL_STATE);
    const [studyBrowserFilters, setStudyBrowserFilters] = useState<StudyBrowserFiltersDto>(INITIAL_FILTERS_STATE);
    const [cachedStudyBrowserFilters, setCachedStudyBrowserFilters] = useState<StudyBrowserFiltersDto>(INITIAL_FILTERS_STATE);
    const [filteredPlants, setFilteredPlants] = useState<PlantDto[]>([])
    const [filteredFactories, setFilteredFactories] = useState<FactoryDto[]>([])
    const [filteredUsers, setFilteredUsers] = useState<UserDto[]>([])
    const [filteredOperaionMasters, SetFilteredOperaionMasters] = useState<OperationMasterDto[]>([])
    const [filteredOperatorMasters, SetFilteredOperatorMasters] = useState<OperatorMasterDto[]>([])

    const [isCommentingRow, setIsCommentingRow] = React.useState(null)
    const [rowComment, setRowComment] = React.useState<StudyRowCommentFormDataDto>(INITIAL_ROW_COMMENT)

    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(APP_TABLE_SETTINGS.DEFAULT_TABLE_PAGE_SIZE);

    const sbuListState = useSelector((state: any) => state.factories.sbuList);
    const shiftListState = useSelector((state: any) => state.shifts.shiftList);
    const userListState = useSelector((state: any) => state.users.userList)
    const studyBrowserListState = useSelector((state: any) => state.studyBrowser.studyBrowserList)

    React.useEffect(() => {
        // dispatch getAllSbuList action & fetch SBU List
        dispatch(
            factoryActions.getAllSbuList(
                authorizationService.getAuthorizedUser().isAdmin,
                authorizationService.getAuthorizedUser().userEmail,
                () => { },
                (error) => {
                    dispatch(alertActions.triggerAlert(true, error, 'error'))
                }
            )
        );
        // dispatch getStudyBrowserList action

        dispatch(userActions.getUserList(null, () => { }, (error) => {
            // trigger alert onError
            dispatch(alertActions.triggerAlert(true, error, 'error'))
        }))
        dispatch(shiftActions.getAllShiftList(() => { }, (error) => {
            // trigger alert onError
            dispatch(alertActions.triggerAlert(true, error, 'error'))
        }))
        return (() => {
            dispatch(studyBrowserActions.clearStudyBrowserList())
        })
    }, [])

    const onFilterClear = () => {
        setStudyBrowserFilters(INITIAL_FILTERS_STATE)
        setCachedStudyBrowserFilters(INITIAL_FILTERS_STATE)
        dispatch(studyBrowserActions.clearStudyBrowserList())
    }

    const loadOperationMasterData = (searchTerm: string) => {
        operationMasterService.getOperationMasters(studyBrowserFilters.plantCode.value,studyBrowserFilters.factoryCode.value, searchTerm)
            .then(res => {
                if(res.data){
                    SetFilteredOperaionMasters(res.data);
                } else{
                    SetFilteredOperaionMasters([]);
                }
            })
            .catch(error => {
                SetFilteredOperaionMasters([]);
            })
    }

    const loadOperatorMasterData = (searchTerm: string) => {
        operatorMasterService.getOperatorMasters(studyBrowserFilters.plantCode.value,studyBrowserFilters.factoryCode.value, searchTerm)
            .then(res => {
                if(res.data){
                    SetFilteredOperatorMasters(res.data);
                } else{
                    SetFilteredOperatorMasters([]);
                }
            })
            .catch(error => {
                SetFilteredOperatorMasters([]);
            })
    }

    const onFilterSearchTermChange = (property: string, value: any) => {
        switch (property) {
            case 'operationMasterId':
                loadOperationMasterData(value);
                break;
            case 'operatorMasterId':
                loadOperatorMasterData(value);
                break;
        }
    }

    const onFilterChange = (property: string, value: any) => {
        switch (property) {
            case 'sbuId':
                const sbuIndex = sbuListState.data.map(s => s.sbuId).indexOf(value)
                setStudyBrowserFilters({
                    ...studyBrowserFilters,
                    sbuId: {
                        ...studyBrowserFilters.sbuId,
                        value: value,
                        error: null
                    },
                    sbuCode: {
                        ...studyBrowserFilters.sbuCode,
                        value: sbuListState.data[sbuIndex].sbuCode
                    },
                    plantId: {
                        ...studyBrowserFilters.plantId,
                        value: ''
                    },
                    plantCode: {
                        ...studyBrowserFilters.plantCode,
                        value: ''
                    },
                    factoryId: {
                        ...studyBrowserFilters.factoryId,
                        value: ''
                    },
                    factoryCode: {
                        ...studyBrowserFilters.factoryCode,
                        value: ''
                    },
                    userEmail: {
                        ...studyBrowserFilters.userEmail,
                        value: ''
                    },
                    userId: {
                        ...studyBrowserFilters.userId,
                        value: ''
                    },
                    operationMasterId: {
                        ...studyBrowserFilters.operationMasterId,
                        value: null
                    },
                    operatorMasterId: {
                        ...studyBrowserFilters.operatorMasterId,
                        value: null
                    }
                })
                setFilteredPlants(sbuListState.data[sbuIndex].plants)
                setFilteredFactories([])
                setFilteredUsers([])
                SetFilteredOperaionMasters([])
                SetFilteredOperatorMasters([])
                break;
            case 'plantId':
                const plantIndex = filteredPlants.map(p => p.id).indexOf(value)
                setStudyBrowserFilters({
                    ...studyBrowserFilters,
                    plantId: {
                        ...studyBrowserFilters.plantId,
                        value: value
                    },
                    plantCode: {
                        ...studyBrowserFilters.plantCode,
                        value: filteredPlants[plantIndex].code
                    },
                    factoryId: {
                        ...studyBrowserFilters.factoryId,
                        value: ''
                    },
                    factoryCode: {
                        ...studyBrowserFilters.factoryCode,
                        value: ''
                    },
                    userEmail: {
                        ...studyBrowserFilters.userEmail,
                        value: ''
                    },
                    userId: {
                        ...studyBrowserFilters.userId,
                        value: ''
                    },
                    operationMasterId: {
                        ...studyBrowserFilters.operationMasterId,
                        value: null
                    },
                    operatorMasterId: {
                        ...studyBrowserFilters.operatorMasterId,
                        value: null
                    }
                })
                setFilteredFactories(filteredPlants[plantIndex].factories)
                setFilteredUsers([])
                SetFilteredOperaionMasters([])
                SetFilteredOperatorMasters([])
                break;
            case 'factoryId':
                const factoryIndex = filteredFactories.map(f => f.id).indexOf(value)
                const filteredUsersList = userListState.data
                    .filter((i) => i.factoryCodes.includes(filteredFactories[factoryIndex].code))
                setStudyBrowserFilters({
                    ...studyBrowserFilters,
                    factoryId: {
                        ...studyBrowserFilters.factoryId,
                        value: value
                    },
                    factoryCode: {
                        ...studyBrowserFilters.factoryCode,
                        value: filteredFactories[factoryIndex].code
                    },
                    userEmail: {
                        ...studyBrowserFilters.userEmail,
                        value: ''
                    },
                    userId: {
                        ...studyBrowserFilters.userId,
                        value: ''
                    },
                    operationMasterId: {
                        ...studyBrowserFilters.operationMasterId,
                        value: null
                    },
                    operatorMasterId: {
                        ...studyBrowserFilters.operatorMasterId,
                        value: null
                    }
                })

                setFilteredUsers(filteredUsersList.sort((a, b) => a.firstName.localeCompare(b.firstName)))
                SetFilteredOperaionMasters([])
                SetFilteredOperatorMasters([])
                break;
            case 'userId':
                const userIndex = userListState.data.map(u => u.id).indexOf(value)
                setStudyBrowserFilters({
                    ...studyBrowserFilters,
                    userEmail: {
                        ...studyBrowserFilters.userEmail,
                        value: userListState.data[userIndex].userEmail
                    },
                    userId: {
                        ...studyBrowserFilters.userId,
                        value: value
                    }
                })
                break;
            case 'operationMasterId':
                setStudyBrowserFilters({
                    ...studyBrowserFilters,
                    operationMasterId: {
                        ...studyBrowserFilters.operationMasterId,
                        value: value
                    }
                })
                break;
            case 'operatorMasterId':
                setStudyBrowserFilters({
                    ...studyBrowserFilters,
                    operatorMasterId: {
                        ...studyBrowserFilters.operatorMasterId,
                        value: value
                    }
                })
                break;
            case 'studyId':
                const studyIndex = APP_STUDIES_LIST.map(s => s.id).indexOf(value)
                setStudyBrowserFilters({
                    ...studyBrowserFilters,
                    studyId: {
                        ...studyBrowserFilters.studyId,
                        value: value
                    },
                    studyName: {
                        ...studyBrowserFilters.studyName,
                        value: APP_STUDIES_LIST[studyIndex].name
                    },
                    gsdCode: {
                        ...studyBrowserFilters.gsdCode,
                        value: ''
                    }
                })
                break;
            default:
                setStudyBrowserFilters({
                    ...studyBrowserFilters,
                    [property]: {
                        ...studyBrowserFilters[property as keyof typeof studyBrowserFilters],
                        value: value,
                        error: null
                    }
                })
        }
    }

    const onFilterApply = async () => {
        const [validatedData, isValid]: any = await utilFunctions.validateFormData(studyBrowserFilters)
        setStudyBrowserFilters(validatedData)
        setCachedStudyBrowserFilters(validatedData)
        if (isValid) {
            const _validatedData = validatedData as StudyBrowserFiltersDto
            const params: StudyBrowserListFiltersParamsDto = {
                sbuCode: _validatedData.sbuCode.value,
                plantCode: _validatedData.plantCode.value,
                factoryCode: _validatedData.factoryCode.value,
                module: _validatedData.module.value,
                shiftCode: _validatedData.shiftCode.value,
                style: _validatedData.style.value,
                createdBy: _validatedData.userEmail.value,
                fromDate: null,
                toDate: null,
                studyName: _validatedData.studyName.value,
                version: _validatedData.version.value,
                gsdCode: _validatedData.gsdCode.value,
                isBestVideo: _validatedData.isBestVideo.value,
                operationMasterId: _validatedData.operationMasterId.value,
                operatorMasterId: _validatedData.operatorMasterId.value
            }
            if (!!_validatedData.dateStart.value) {
                params[`fromDate`] = new Date(_validatedData.dateStart.value).toISOString()
            }
            if (!!_validatedData.dateEnd.value) {
                params[`toDate`] = new Date(_validatedData.dateEnd.value).toISOString()
            }

            dispatch(studyBrowserActions.getStudyBrowserList(params,
                () => {
                    setPage(0)
                },
                (error) => {
                    // trigger alert onError
                    dispatch(alertActions.triggerAlert(true, error, 'error'))
                }))
        }
    }

    const onStudyDetailView = (studyId: number, studyTypeId: number) => {
        dispatch(studyBrowserActions.getStudyBrowserDetail(studyId,
            (res) => {
                let opetaions = []
                switch (studyTypeId) {
                    case APP_STUDIES.PROTENTIAL:
                        const gropuedOpByName = utilFunctions.groupArray(res.studyDetail.studyOperationTimes, 'operationName')
                        for (const item in gropuedOpByName) {
                            const _operationGroup = {
                                groupName: item,
                                operations: []
                            }
                            for (const op of gropuedOpByName[`${item}`]) {
                                _operationGroup.operations.push({
                                    id: op.id,
                                    operationId: op.operationId,
                                    operationName: op.operationName,
                                    cycleTime: +(op.cycleTime / 1000).toFixed(1),
                                    isFlagged: op.isFlagged,
                                    isCancelled: op.isCancelled
                                })
                            }
                            opetaions.push(_operationGroup);
                        }
                        break;

                    case APP_STUDIES.PRODUCTION:
                        const prGropuedOpByName = utilFunctions.groupArray(res.studyDetail.studyOperationTimes, 'operationName')
                        for (const item in prGropuedOpByName) {
                            const _operationGroup = {
                                groupName: item,
                                operations: []
                            }

                            //  ---------------------------------------
                            for (const op of prGropuedOpByName[`${item}`]) {
                                _operationGroup.operations.push({
                                    id: op.id,
                                    operationId: op.operationId,
                                    operationName: op.operationName,
                                    cycleTime: +(op.cycleTime / 1000).toFixed(1),
                                    isFlagged: op.isFlagged,
                                    isCancelled: op.isCancelled
                                })
                            }
                            opetaions.push(_operationGroup);
                        }
                        break;

                    case APP_STUDIES.YAMAZUMI:
                        const gropuedOpByTeamMember = utilFunctions.groupArray(res.studyDetail.studyOperationTimes, 'teamMemberName')
                        for (const teamMember in gropuedOpByTeamMember) {
                            const groupedOpByName = utilFunctions.groupArray(gropuedOpByTeamMember[`${teamMember}`], 'operationName')
                            for (const group in groupedOpByName) {
                                const _operationGroup = {
                                    groupName: `${teamMember} - ${group}`,
                                    sequenceNo: gropuedOpByTeamMember[`${teamMember}`][0].sequenceNo,
                                    operations: []
                                }
                                for (const op of groupedOpByName[`${group}`]) {
                                    _operationGroup.operations.push({
                                        id: op.id,
                                        operationId: op.operationId,
                                        operationName: op.operationName,
                                        cycleTime: +(op.cycleTime / 1000).toFixed(1),
                                        isFlagged: op.isFlagged,
                                        isCancelled: op.isCancelled,
                                    })
                                }
                                opetaions.push(_operationGroup);
                            }
                        }
                        // sort data by sequenceNo
                        opetaions.sort((a, b) => {
                            return a.sequenceNo - b.sequenceNo
                        })
                        break;
                    case APP_STUDIES.WORK_COMBINATION_AND_TIME_STUDY:
                        const groupedOpByName = utilFunctions.groupArray(res.studyDetail.studyOperationTimes, 'operationName')
                        for (const opName in groupedOpByName) {
                            for (const op of groupedOpByName[`${opName}`]) {
                                const elementsTimes = op.studyElementTimes.map(e => {
                                    return ({
                                        ...e,
                                        elementName: `${e.sequenceNo} - ${e.elementName}`
                                    })
                                })
                                const groupedByElementName = utilFunctions.groupArray(elementsTimes, 'elementName')
                                for (const elmName in groupedByElementName) {
                                    const _operationGroup = {
                                        groupName: `${opName} - ${elmName}`,
                                        operations: []
                                    }
                                    for (const element of groupedByElementName[`${elmName}`]) {
                                        _operationGroup.operations.push({
                                            id: element.id,
                                            operationId: op.studyElementId,
                                            operationName: element.operationName,
                                            cycleTime: +(element.cycleTime / 1000).toFixed(1),
                                            isFlagged: element.isFlagged,
                                            isCancelled: element.isCancelled
                                        })
                                    }
                                    opetaions.push(_operationGroup);
                                }

                            }
                        }
                        break;

                    default:
                        opetaions = [];
                }
                setStudyBrowserPageState({
                    ...studyBrowserPageState,
                    studyDetailPopup: true,
                    studyDetailPopupData: opetaions
                });
            },
            (error) => {
                dispatch(alertActions.triggerAlert(true, error, 'error'))
            }))
    }

    const onAdditionalActivityView = (studyId: number, studyTypeId: number) => {
        dispatch(studyBrowserActions.getStudyBrowserDetail(studyId, (res) => {
            let opetaions = []
            const gropuedOpByName = utilFunctions.groupArray(res.studyDetail.studyOperationTimes, 'operationName')
            for (const item in gropuedOpByName) {
                //calculate opAdditionalActivityTimesSum
                for (const op of gropuedOpByName[`${item}`]) {
                    const gropuedAat = utilFunctions.groupArray(op.additionalActivityTimes, 'typeName')
                    for (const aatType in gropuedAat) {
                        let aatIndex = 1;
                        const _operationGroup = {
                            groupName: `${item}-${aatType}`,
                            operations: []
                        }
                        for (const aat of gropuedAat[`${aatType}`]) {
                            _operationGroup.operations.push({
                                no: aatIndex,
                                frequency: aat.frequency,
                                time: +(aat.time / 1000).toFixed(1)
                            })
                            aatIndex++
                        }
                        opetaions.push(_operationGroup);
                    }

                }
            }
            setStudyBrowserPageState({
                ...studyBrowserPageState,
                aatDetailPopup: true,
                aatDetailPopupData: opetaions
            });
        },
            (error) => {
                dispatch(alertActions.triggerAlert(true, error, 'error'))
            }))
    }

    const toggleStudyDetailPopup = (status: boolean, data: any) => {
        setStudyBrowserPageState({
            ...studyBrowserPageState,
            studyDetailPopup: status,
            studyDetailPopupData: data
        });
    };

    const toggleAatDetailPopup = (status: boolean, data: any) => {
        setStudyBrowserPageState({
            ...studyBrowserPageState,
            aatDetailPopup: status,
            aatDetailPopupData: data
        });
    };

    const onVideoView = (url: string) => {
        setStudyBrowserPageState({
            ...studyBrowserPageState,
            videoPopup: true,
            videoPopupUrl: url
        });
    }

    const toggleVideoPopup = (status: boolean, url: string) => {
        setStudyBrowserPageState({
            ...studyBrowserPageState,
            videoPopup: status,
            videoPopupUrl: url
        });
    };

    const onPotentialReportView = (studyId: number) => {
        dispatch(studyBrowserActions.getStudyBrowserDetail(studyId,
            (res) => {
                // Group operations by operationName
                const formattedOperations = utilFunctions.groupArray(res.studyDetail.studyOperationTimes, 'operationName')

                // convert total elapsed time from milliseconds to minutes & seconds
                const [elapsedTimeMinutes, elapsedTimeSeconds] = utilFunctions.millisecondsToMinAndSec(res.studyDetail.elapsedTime)

                // init formatted report data object
                let _reportData = {
                    isMultiple: res.studyDetail.isMultipleOperation,
                    createdAt: utilFunctions.formatDateTime(res.createdAt),
                    totalElapsedTime: {
                        min: elapsedTimeMinutes,
                        sec: elapsedTimeSeconds
                    },
                    epf: res.studyDetail.studyOperationTimes[0].epf || '',
                    isVideoOn: res.studyDetail.isVideoOn,
                    teamMemberName: res.studyDetail.studyOperationTimes[0].teamMemberName || '',
                    operations: []
                }

                // observe each operation group
                for (const operation in formattedOperations) {
                    // init formatted operation object
                    let _operation = {
                        name: operation,
                        studyPcs: [],
                        gsd: formattedOperations[`${operation}`][0].ssv || 0,
                        actual: +formattedOperations[`${operation}`][0].bestCT.toFixed(1) || 0,
                        pcs: +formattedOperations[`${operation}`][0].pcs.toFixed(1) || 0, //CHECK
                        avgCT: +formattedOperations[`${operation}`][0].avgCT.toFixed(1) || 0,
                        bestCT: +formattedOperations[`${operation}`][0].bestCT.toFixed(1) || 0,
                        performance: +formattedOperations[`${operation}`][0].performance.toFixed(1) || 0, // CHECK
                        isActualCycles: []
                    };
                    // generate study operation times chart data & filter total study PCS
                    const studyOperationTimesXAxis = []
                    const studyOperationTimesYAxis = []
                    let ctIndex = 1
                    for (const pcs of formattedOperations[`${operation}`]) {
                        // filter isCancelled=FALSE studyPcs
                        if (!pcs.isCancelled) {
                            _operation.studyPcs.push(pcs);

                            // convert cycleTime from milliseconds to seconds
                            const convertedCycleTime = +(pcs.cycleTime / 1000).toFixed(1);
                            // set studyOperationTimes bar chart data
                            studyOperationTimesXAxis.push(ctIndex);
                            studyOperationTimesYAxis.push(convertedCycleTime);
                            ctIndex++

                            // filter cycleTime = actual pcs
                            if (+pcs.bestCT.toFixed(1) == convertedCycleTime) {
                                _operation.isActualCycles.push(pcs)
                            }
                        }

                    }
                    // set operationTimeChart data
                    _operation[`operationTimesChart`] = {
                        x: studyOperationTimesXAxis,
                        y: studyOperationTimesYAxis
                    };
                    // generate PCSLineChart (SSV vs CT CHART) data
                    const pcsLineChartGsd = [];
                    for (const val of studyOperationTimesXAxis) {
                        pcsLineChartGsd.push(formattedOperations[`${operation}`][0].ssv)
                    }
                    _operation[`pcsLineChart`] = {
                        y1: pcsLineChartGsd,
                        y2: studyOperationTimesYAxis,
                        x: studyOperationTimesXAxis,
                    };

                    // push formatted operation object to reportData object
                    _reportData.operations.push(_operation);
                }

                // calculate total study pcs or all operations
                const totalStudyPcs = [];
                for (const pcs of res.studyDetail.studyOperationTimes) {
                    if (!pcs.isCancelled) {
                        totalStudyPcs.push(pcs);
                    }
                }
                _reportData[`totalStudyPcs`] = totalStudyPcs.length;

                // init report summery object
                const summery = {
                    gsd: 0,
                    actual: 0,
                    pcs: 0,
                    avgCT: 0,
                    bestCT: 0,
                    performance: 0,
                    operationTimesChart: {
                        gsd: [],
                        actual: [],
                        operation: []
                    },
                    pcsLineChart: {
                        y1: [],
                        y2: [],
                        x: []
                    }
                };
                // is isMultipleOperation=TRUE calculate report Summery
                if (res.studyDetail.isMultipleOperation) {
                    // observe each formatted operation inside reportData object
                    for (const op of _reportData.operations) {
                        summery.gsd += op.gsd;
                        summery.actual += op.actual;
                        summery.avgCT += op.avgCT;
                        summery.bestCT += op.bestCT;
                        summery.operationTimesChart.gsd.push(+op.gsd.toFixed(1));
                        summery.operationTimesChart.actual.push(+op.actual.toFixed(1));
                        summery.operationTimesChart.operation.push(op.name);
                        summery.pcsLineChart.y1.push(op.gsd)
                        summery.pcsLineChart.y2.push(op.bestCT)
                        summery.pcsLineChart.x.push(op.name)
                    }
                    // calculate summery pcs & performance
                    summery.pcs = Math.floor(3600 / summery.bestCT); // CHECK
                    summery.performance = Math.floor(summery.gsd / summery.bestCT * 100) // CHECK
                }
                // round data
                summery.gsd = +summery.gsd.toFixed(1)
                summery.actual = +summery.actual.toFixed(1)
                summery.avgCT = +summery.avgCT.toFixed(1)
                summery.bestCT = +summery.bestCT.toFixed(1)
                // add summery object to reportData object
                _reportData[`summery`] = summery;
                // update state & trigger report popup
                setStudyBrowserPageState({
                    ...studyBrowserPageState,
                    potentialReportPopup: true,
                    potentialReportPopupData: _reportData
                });
            },
            (error) => {
                dispatch(alertActions.triggerAlert(true, error, 'error'))
            }))
    }

    const togglePotentialReportPopup = (status: boolean, data: any) => {
        setStudyBrowserPageState({
            ...studyBrowserPageState,
            potentialReportPopup: status,
            potentialReportPopupData: data
        });
    };

    const onYamazumiEbReportView = (studyId: number) => {
        dispatch(studyBrowserActions.getStudyDependentDetail(studyId,
            (res) => {
                let elementCategories = [];
                let yamazumiChartData = createYamazumiChartObj(res);//initiate chart object
                // convert total elapsed time from milliseconds to minutes & seconds
                const [elapsedTimeMinutes, elapsedTimeSeconds] = utilFunctions.millisecondsToMinAndSec(res.studyDetail.elapsedTime)
                yamazumiChartData.totalElapsedTime.min = elapsedTimeMinutes;
                yamazumiChartData.totalElapsedTime.sec = elapsedTimeSeconds;
                // ---------------STEP01-------------------------------
                // sort data by sequenceNo
                const data = res.studyDetail.studyOperationTimes
                data.sort((a, b) => a.sequenceNo - b.sequenceNo)
                // group operations by epf
                //const formattedOperations = utilFunctions.groupArray(data, 'epf')
                // refer each operation for team member
                let teamMembers = [];
                setTeamMembers(data, teamMembers, true);
                //sort team members
                teamMembers.sort((a, b) => a.sequenceNo - b.sequenceNo);
                yamazumiChartData.teamMemberRawData = teamMembers;
                // ---------------STEP02-------------------------------
                // refer each team member of teamMembers array
                for (const tm of teamMembers) {
                    // group rawElementTimes by elementCategoryId
                    const groupedElementTimes = utilFunctions.groupArray(tm.rawElementTimes, 'elementCategoryId')
                    const processedElementTimes = [];
                    for (const groupedElement in groupedElementTimes) {
                        const element = {
                            name: '',
                            cycleTimeSum: 0
                        }
                        for (const elm of groupedElementTimes[`${groupedElement}`]) {
                            if (elementCategories.indexOf(`${elm.elementCategoryName}~${elm.elementCategoryId}`) < 0) {
                                elementCategories.push(`${elm.elementCategoryName}~${elm.elementCategoryId}`)
                            }
                            element.name = elm.elementCategoryName;
                            element.cycleTimeSum += elm.cycleTime;

                        }
                        processedElementTimes.push(element)
                    }
                    tm[`processedElementTime`] = processedElementTimes;
                }

                // ---------------STEP03 GENERATE CHART DATA-----------------
                const datasets = [];
                const categories = []
                let colorIndex = 0
                for (const elm of elementCategories) {
                    const emlCatName = elm.split('~')[0]
                    const emlCatId = +elm.split('~')[1]
                    const _column = {
                        type: 'bar' as const,
                        label: emlCatName,
                        data: [],
                        backgroundColor: '',
                        stack: 'stackBar' // if this key value is changes STEP 04 needs to be updated
                    }
                    colorIndex += 1
                    for (const member of teamMembers) {
                        if (categories.indexOf(`${member.name}~${member.epf}`) < 0) {
                            categories.push(`${member.name}~${member.epf}`)/* member.name + member.epf */
                        }
                        const elmIndex = member.processedElementTime.map(e => e.name).indexOf(emlCatName)
                        if (elmIndex > -1) {
                            _column.data.push(+(member.processedElementTime[elmIndex].cycleTimeSum / 1000).toFixed(1))
                        } else {
                            _column.data.push(0)
                        }
                    }
                    switch (emlCatId) {
                        case APP_EML_CATEGORY.MANUAL:
                            _column.backgroundColor = '#f44336';
                            break;

                        case APP_EML_CATEGORY.AUTO:
                            _column.backgroundColor = '#45d24a';
                            break;

                        case APP_EML_CATEGORY.WALK:
                            _column.backgroundColor = '#03a9f4';
                            break;

                        case APP_EML_CATEGORY.MACHINE_TIME:
                            _column.backgroundColor = '#ffc107';
                            break;

                        default:
                            break;

                    }
                    datasets.push(_column)

                }

                // alter CHART DATA with dependent study details
                const processedIsBestCycleTimes = []
                for (const dependentStudy of res.dependentStudies) {
                    if (dependentStudy.studyHeader.studyTypeId === 1
                        || dependentStudy.studyHeader.studyTypeId === 3
                        || dependentStudy.studyHeader.studyTypeId === 4) {
                        const isBestCycleTimes = dependentStudy.studyDetail.studyOperationTimes.filter(i => 
                            dependentStudy.studyHeader.studyTypeId === 4 || i.isBestCycle === true)//if Time study only one operation time and isBestCycle not set
                        const groupedCycleTimes = utilFunctions.groupArray(isBestCycleTimes, 'epf')

                        for (const epf in groupedCycleTimes) {
                            const item = {
                                epf: epf,
                                bestCT: 0
                            }
                            for (const ct of groupedCycleTimes[epf]) {
                                item.bestCT += ct.bestCT
                            }
                            processedIsBestCycleTimes.push(item)
                        }
                    }

                }

                const dependentStudies = []
                let empIndex = 0
                for (const emp of categories) {
                    const _empData = emp.split('~')
                    const selectedEmployeeEPF = _empData[_empData.length - 1];
                    // console.log('selectedEmployeeEPF',selectedEmployeeEPF)

                    const filteredEmpCycleTimes = processedIsBestCycleTimes.filter(i => i.epf === selectedEmployeeEPF)
                    let studyIndex = 0
                    for (const study of filteredEmpCycleTimes) {
                        const _data = !!dependentStudies[studyIndex]?.data ? dependentStudies[studyIndex].data : []
                        _data[empIndex] = study.bestCT
                        dependentStudies[studyIndex] = {
                            type: 'bar' as const,
                            label: studyIndex + 1, // potential study1
                            data: _data,
                            backgroundColor: 'rgb(53, 162, 235)',
                            stack: studyIndex.toString(),
                        }
                        studyIndex += 1
                    }

                    empIndex += 1
                }

                // Bind data
                yamazumiChartData.categories = categories;
                yamazumiChartData.datasets = [...datasets, ...dependentStudies];

                // ---------------STEP04 FIND phaseMakerCT VALUE----------------
                const processedGropData = []
                // prepare grouped process data by category
                for (let c = 0; yamazumiChartData.categories.length > c; c++) {
                    const processedCategory = []
                    let categoryYamazumiTotal = 0
                    for (const row of datasets) {
                        categoryYamazumiTotal += row.data[c]
                    }
                    processedCategory[0] = categoryYamazumiTotal

                    for (let i = 0; dependentStudies.length > i; i++) {
                        if (dependentStudies[i].data[c]) {
                            processedCategory[i + 1] = dependentStudies[i].data[c]
                        }

                    }
                    processedGropData.push(processedCategory)

                }

                // get the latest value from each group
                const latestGroupValues = []
                for (const group of processedGropData) {
                    if (group.length > 0) {
                        latestGroupValues.push(group[group.length - 1])
                    } else if (group.length === 0) {
                        latestGroupValues.push(group[0])
                    }
                }

                const phaseMakerCT = +Math.max.apply(Math, latestGroupValues).toFixed(1)
                const potentialPC = Math.floor(3600 / phaseMakerCT)
                const totalOperators = categories.length
                yamazumiChartData.phaseMakerCT = phaseMakerCT
                yamazumiChartData.potentialPC = potentialPC
                yamazumiChartData.moduleEfficiency = +(potentialPC / ((60 * totalOperators) / +res.studyDetail.totalSMV.toFixed(1)) * 100).toFixed(1)

                setStudyBrowserPageState({
                    ...studyBrowserPageState,
                    yamazumiEbReportPopup: true,
                    yamazumiEbReportPopupData: yamazumiChartData
                });
            },
            (error) => {
                dispatch(alertActions.triggerAlert(true, error, 'error'))
            }
        ))
    }

    const toggleYamazumiEbReportPopup = (status: boolean, data: any) => {
        setStudyBrowserPageState({
            ...studyBrowserPageState,
            yamazumiEbReportPopup: status,
            yamazumiEbReportPopupData: data
        });
    };

    const onYamazumiNebReportView = (studyId: number) => {

        dispatch(studyBrowserActions.getStudyDependentDetail(studyId,
            (res) => {
                const operations = [];
                const dependentStudyIds = [];
                let teamMembers = []; 
                let datasets = [];
                // operation to color mapping
                const operationColorMap = {};
                let colorIndex = 0;
                let yamazumiChartData = createYamazumiChartObj(res);//initiate chart object
                // convert total elapsed time from milliseconds to minutes & seconds
                const [elapsedTimeMinutes, elapsedTimeSeconds] = utilFunctions.millisecondsToMinAndSec(res.studyDetail.elapsedTime)
                yamazumiChartData.totalElapsedTime.min = elapsedTimeMinutes;
                yamazumiChartData.totalElapsedTime.sec = elapsedTimeSeconds;
                //Theoritical
                if(res.studyDetail.isTheoritical){
                    // group operations by epf
                    teamMembers = getTheoriticalTeamMembers(res);
                    teamMembers.sort((a, b) => {
                        return a.sequenceNo - b.sequenceNo
                    })
                    for (const tm of teamMembers) {
                        // group operations by operationName
                        const groupedOperations = utilFunctions.groupArray(tm.operations, 'operationName')
                        for (const groupedOperation in groupedOperations) {
                            for (const op of groupedOperations[`${groupedOperation}`]) {
                                if (operations.indexOf(op.operationName) < 0) {
                                    operations.push(op.operationName)
                                }
                            }
                        }
                    }
                    //create data set
                    for (const opName of operations) {
                        const _column = {
                            type: 'bar' as const,
                            label: opName,
                            data: [],
                            backgroundColor: CHART_COLOR_PALETTE[colorIndex],
                            stack: '-1' // if this key value is changes STEP 04 needs to be updated
                        }
                        operationColorMap[opName] = colorIndex;
                        colorIndex += 1
                        for (const member of teamMembers) {
                            const opIndex = member.formattedOperations.map(e => e.oprationName).indexOf(opName)
                            if (opIndex > -1) {
                                _column.data.push(member.formattedOperations[opIndex].bestCT)
                            } else {
                                _column.data.push(0)
                            }
                        }
                        datasets.push(_column)
    
                    }
                    yamazumiChartData.datasets = [...datasets];
                }
                //End theoritical

                // ---------------STEP01-------------------------------
                // filter isBestCycle true AND isCancelled false operations
                const filteredOperationTimes = res.studyDetail.studyOperationTimes.filter(i => i.isBestCycle === true && i.isCancelled === false);
                // sort data base on sequenceNo
                filteredOperationTimes.sort((a, b) => a.sequenceNo - b.sequenceNo)
                // group operations by epf
                //const formattedOperations = utilFunctions.groupArray(filteredOperationTimes, 'epf')
                // refer each operation for team member
                setTeamMembers(filteredOperationTimes, teamMembers, false);
                yamazumiChartData.teamMemberRawData = teamMembers;
                // ---------------STEP02-------------------------------
                // refer each team member of teamMembers array
                for (const tm of teamMembers) {
                    // group operations by operationName
                    const groupedOperations = utilFunctions.groupArray(tm.operations, 'operationName')

                    const processedOperations = [];
                    for (const groupedOperation in groupedOperations) {
                        const operation = {
                            name: '',
                            cycleTimeSum: 0
                        }
                        for (const op of groupedOperations[`${groupedOperation}`]) {
                            if (operations.indexOf(op.operationName) < 0) {
                                operations.push(op.operationName)
                            }
                            operation.name = op.operationName;
                            operation.cycleTimeSum += op.cycleTime > 0 ? (op.cycleTime * (op.workloadPerc / 100)) : 0;

                        }
                        processedOperations.push(operation)
                    }
                    tm[`processedOperations`] = processedOperations;
                }

                // ---------------STEP03 GENERATE CHART DATA-----------------
                const categories = [];
                datasets = [];
                //let colorIndex = 0;
                // sort data by sequenceNo
                teamMembers.sort((a, b) => {
                    return a.sequenceNo - b.sequenceNo
                })
                for (const op of operations) {
                    const _column = {
                        type: 'bar' as const,
                        label: op,
                        data: [],
                        backgroundColor: CHART_COLOR_PALETTE[colorIndex],
                        stack: '0' // if this key value is changes STEP 04 needs to be updated
                    }
                    if(!operationColorMap[op]) {
                        operationColorMap[op] = colorIndex;
                        colorIndex += 1
                    }
                    for (const member of teamMembers) {
                        if (categories.indexOf(`${member.name}~${member.epf}`) < 0) {
                            categories.push(`${member.name}~${member.epf}`)
                        }
                        const opIndex = member.processedOperations.map(e => e.name).indexOf(op)
                        if (opIndex > -1) {
                            _column.data.push(+(member.processedOperations[opIndex].cycleTimeSum / 1000).toFixed(1))
                        } else {
                            _column.data.push(0)
                        }
                    }
                    yamazumiChartData.datasets.push(_column);
                    datasets.push(_column);

                }
                //yamazumiChartData.datasets = [...datasets]
                // alter CHART DATA with dependent study details
                const processedIsBestCycleTimes = []
                for (const dependentStudy of res.dependentStudies) {
                    if (dependentStudy.studyHeader.studyTypeId === 1
                        || dependentStudy.studyHeader.studyTypeId === 3
                        || dependentStudy.studyHeader.studyTypeId === 4) {
                        dependentStudyIds.push(dependentStudy.studyHeader.studyId)
                        const isBestCycleTimes = dependentStudy.studyDetail.studyOperationTimes.filter(i => 
                            dependentStudy.studyHeader.studyTypeId === 4 || i.isBestCycle === true)//if Time study only one operation time and isBestCycle not set
                        const groupedCycleTimes = utilFunctions.groupArray(isBestCycleTimes, 'epf')

                        for (const epf in groupedCycleTimes) {
                            const groupedImprovementOperations = utilFunctions.groupArray(groupedCycleTimes[epf], 'operationName')
                            for (const groupedImprovementOperation in groupedImprovementOperations) {
                                const item = {
                                    epf: epf,
                                    studyId: dependentStudy.studyHeader.studyId,
                                    operationName: groupedImprovementOperation,
                                    bestCT: 0
                                }
                                for (const improvementOperation of groupedImprovementOperations[groupedImprovementOperation]) {

                                    var _depWorkloadPerc = improvementOperation.workloadPerc2 > 0 ? improvementOperation.workloadPerc2 : improvementOperation.workloadPerc
                                    item.bestCT += (improvementOperation.bestCT * (_depWorkloadPerc / 100))
                                }
                                processedIsBestCycleTimes.push(item)
                            }
                        }
                    }
                }

                const dependentStudies = []
                let empIndex = 0
                for (const emp of categories) {
                    const _empData = emp.split('~')
                    const selectedEmployeeEPF = _empData[_empData.length - 1];
                    const filteredEmpCycleTimes = processedIsBestCycleTimes.filter(i => i.epf === selectedEmployeeEPF)
                    const studyIds = filteredEmpCycleTimes.map(i => i.studyId)
                    for (const study of filteredEmpCycleTimes) {
                        const stackIndex = studyIds.indexOf(study.studyId) + 1;
                        const studyIndex = dependentStudyIds.indexOf(study.studyId);
                        const _data = !!dependentStudies[studyIndex]?.data ? dependentStudies[studyIndex].data : []
                        _data[empIndex] = study.bestCT
                        const dataset = {
                            type: 'bar' as const,
                            label: study.operationName, // potential study1
                            data: _data,
                            backgroundColor: !CHART_COLOR_PALETTE[operationColorMap[study.operationName]]
                                ? CHART_COLOR_PALETTE[colorIndex] : CHART_COLOR_PALETTE[operationColorMap[study.operationName]],
                            stack: stackIndex.toString(), // if this key value is changes STEP 04 needs to be updated
                        }
                        dependentStudies[studyIndex] = dependentStudies[studyIndex] ? [...dependentStudies[studyIndex], dataset] : [dataset]
                        yamazumiChartData.datasets.push(dataset)
                    }
                    empIndex += 1
                }

                // Bind data
                yamazumiChartData.categories = categories;
                // yamazumiChartData.datasets = [...datasets, ...dependentStudies];

                // ---------------STEP04 FIND phaseMakerCT VALUE----------------
                const processedGropData = []
                // prepare grouped process data by category
                for (let c = 0; yamazumiChartData.categories.length > c; c++) {
                    const processedCategory = []
                    let categoryYamazumiTotal = 0
                    for (const row of datasets) {
                        categoryYamazumiTotal += row.data[c]
                    }
                    processedCategory[0] = categoryYamazumiTotal
                    for (let i = 0; dependentStudies.length > i; i++) {
                        if (dependentStudies[i]) {
                            for (const ds of dependentStudies[i]) {
                                if (ds.data[c]) {
                                    processedCategory[i + 1] = processedCategory[i + 1] ? processedCategory[i + 1] + ds.data[c] : ds.data[c]
                                }
                            }
                        }
                    }
                    processedGropData.push(processedCategory)

                }

                // get the latest value from each group
                const latestGroupValues = []
                for (const group of processedGropData) {
                    if (group.length > 0) {
                        latestGroupValues.push(group[group.length - 1])
                    } else if (group.length === 0) {
                        latestGroupValues.push(group[0])
                    }
                }

                const phaseMakerCT = +Math.max.apply(Math, latestGroupValues).toFixed(1)
                const potentialPC = Math.floor(3600 / phaseMakerCT)
                const totalOperators = categories.length
                yamazumiChartData.phaseMakerCT = phaseMakerCT
                yamazumiChartData.potentialPC = potentialPC
                yamazumiChartData.moduleEfficiency = +(potentialPC / ((60 * totalOperators) / +res.studyDetail.totalSMV.toFixed(1)) * 100).toFixed(1)

                setStudyBrowserPageState({
                    ...studyBrowserPageState,
                    yamazumiNebReportPopup: true,
                    yamazumiNebReportPopupData: yamazumiChartData
                });
            },
            (error) => {
                dispatch(alertActions.triggerAlert(true, error, 'error'))
            }
        ))
    }

    const getTheoriticalTeamMembers = (data) => {
        let teamMembers = [];
        if(data.studyDetail.isTheoritical){
            // group operations by epf
            const tmOperationsGrp = utilFunctions.groupArray(data.theoriticalStudyDetail.theoriticalStudyOperationTimes, 'teamMemberNo');
            for (const tm in tmOperationsGrp) {
                let teamMember: Record<string, any> = {
                    name: null,
                    epf: null,
                    sequenceNo: null,                
                    formattedOperations: [],
                    operations: []
                }                
                // refear each elementTime for team member operation
                for (const operation of tmOperationsGrp[`${tm}`]) {

                    // set data for chart bar info popup
                    const op = {
                        tmName: operation.teamMemberName,
                        oprationName: operation.operationName,
                        bestCT: (operation.smv*60),//second time
                        performance: null,
                        allocation: null,
                        alloMTS: null,
                        potPCS: null

                    };
                    teamMember.epf = operation.epf;
                    teamMember.name = operation.teamMemberName;
                    teamMember.formattedOperations.push(op);
                    teamMember.sequenceNo = operation.teamMemberNo;//user TM# as sequence
                    teamMember.operations.push(operation);
                }
                // push teamMember object to teamMembers array
                teamMembers.push(teamMember)
            }
            return teamMembers;
        }
    }

    const setTeamMembers = (operationTimes, teamMembers : any[], isElement) => {
        const epfOperationsGrp = utilFunctions.groupArray(operationTimes, 'epf')
        for (const epf in epfOperationsGrp) {
            let teamMember = null;
            //get if TM exists
            if(teamMembers.length > 0){
                teamMember = teamMembers.find(e => e.epf === epf);
            }
            if(!teamMember){
                teamMember = {
                    name: null,
                    epf: null,
                    sequenceNo: null,                
                    formattedOperations: []
                };
                teamMembers.push(teamMember)
            }
            if(isElement){
                teamMember.rawElementTimes = [];
            } else {
                teamMember.operations = [];
            }
            // refear each elementTime for team member operation
            for (const operation of epfOperationsGrp[`${epf}`]) {

                // set data for chart bar info popup
                const _workloadPerc = operation.workloadPerc2 > 0 ? operation.workloadPerc2 : operation.workloadPerc
                const op = {
                    tmName: operation.teamMemberName,
                    oprationName: operation.operationName,
                    bestCT: operation.bestCT.toFixed(1),
                    performance: operation.performance.toFixed(0),
                    allocation: _workloadPerc,
                    alloMTS: (60 * _workloadPerc / 100).toFixed(0),
                    potPCS: (3600 * (_workloadPerc / 100) / operation.bestCT).toFixed(0)

                };
                teamMember.epf = operation.epf;
                teamMember.name = operation.teamMemberName;
                teamMember.formattedOperations.push(op);
                if(!teamMember.sequenceNo){
                    teamMember.sequenceNo = operation.sequenceNo;
                }
                if(isElement) {
                    for (const elementTime of operation.studyElementTimes) {
                        // push rawElementTimes to teamMember object
                        if (elementTime.isBestCycle && elementTime.isCancelled === false) {
                            teamMember.rawElementTimes.push({
                                ...elementTime,
                                cycleTime: elementTime.cycleTime * _workloadPerc / 100
                            });
                        }
                    }
                } else {
                    teamMember.operations.push(operation);
                }
            }
        }
    }

    const createYamazumiChartObj = (res) => {
        return {
            categories: [],
            teamMemberRawData: [],
            datasets: [],
            totalElapsedTime: {
                min: '0',
                sec: '0'
            },
            createdAt: utilFunctions.formatDateTime(res.createdAt),
            module: res.studyHeader.module,
            style: res.studyHeader.style,
            version: res.studyHeader.version,
            phaseMakerCT: 0,
            potentialPC: 0,
            balancingLoss: +res.studyDetail.balancingLoss.toFixed(1),
            isElementBased: res.studyDetail.isElementBased,
            isMultipleOperation: res.studyDetail.isMultipleOperation,
            totalSMV: +res.studyDetail.totalSMV.toFixed(1),
            tactTime: res.studyDetail.tactTime,
            pitchTime: res.studyDetail.pitchTime,
            psd: res.studyDetail.psd,
            yamazumiType: res.studyDetail.yamazumiType,
            noOfOperationImproved: res.studyDetail.noOfOperationImproved,
            moduleEfficiency: 0
        }
    }

    const toggleYamazumiNebReportPopup = (status: boolean, data: any) => {
        setStudyBrowserPageState({
            ...studyBrowserPageState,
            yamazumiNebReportPopup: status,
            yamazumiNebReportPopupData: data
        });
    };

    const onProductionReportView = (studyId: number) => {
        dispatch(studyBrowserActions.getStudyBrowserDetail(studyId,
            (res) => {
                const productionReportData = {
                    isMultiple: res.studyDetail.isMultipleOperation,
                    operations: [],
                    summary: {
                        createdAt: utilFunctions.formatDateTime(res.createdAt),
                        epf: res.studyDetail.studyOperationTimes[0].epf,
                        tmName: res.studyDetail.studyOperationTimes[0].teamMemberName,
                        isMultiple: res.studyDetail.isMultipleOperation,
                        style: res.studyHeader.style,
                        module: res.studyHeader.module,
                        operationName: 'Summary',
                        rawTotalProductiveTime: 0,
                        rawTotalNonProductiveTime: 0,
                        bestCT: 0,
                        ssv: 0,
                        performance: 0,
                        potentialPCS: res.studyDetail.potentialPC,
                        fastestCT: 0,
                        watchError: res.studyDetail.watchError,
                        totalStudyPCS: 0,
                        rawTotalElapsedTime: 0,
                        potentialVsActual: 0,
                        totalElapsedTime: { min: '0', sec: '0' },
                        totalProductiveTime: { min: '0', sec: '0' },
                        totalNonProductiveTime: { min: '0', sec: '0' },
                        totalTimeAnalysis: { series: [], labels: [] },
                        nonProductiveAnalysis: { series: [], labels: [] },
                    }
                }

                let opFactestCtList = []
                const groupedOperations = utilFunctions.groupArray(res.studyDetail.studyOperationTimes, 'operationName')
                for (const operationName in groupedOperations) {
                    const _operation = {
                        createdAt: utilFunctions.formatDateTime(res.createdAt),
                        epf: res.studyDetail.studyOperationTimes[0].epf,
                        tmName: res.studyDetail.studyOperationTimes[0].teamMemberName,
                        isMultiple: res.studyDetail.isMultipleOperation,
                        style: res.studyHeader.style,
                        module: res.studyHeader.module,
                        operationName: operationName,
                        rawTotalProductiveTime: 0,
                        rawTotalNonProductiveTime: 0,
                        bestCT: 0,
                        performance: 0,
                        ssv: 0,
                        potentialPCS: 0,
                        fastestCT: 0,
                        watchError: 0,
                        totalStudyPCS: 0,
                        rawTotalElapsedTime: 0,
                        potentialVsActual: 0,
                        totalElapsedTime: { min: '0', sec: '0' },
                        totalProductiveTime: { min: '0', sec: '0' },
                        totalNonProductiveTime: { min: '0', sec: '0' },
                        totalTimeAnalysis: { series: [], labels: [] },
                        nonProductiveAnalysis: { series: [], labels: [] },
                    }
                    let validCycleTimes = [];
                    const rawNonProductiveTimes = []
                    let opAdditionalActivityTimesSum = 0
                    let npOtherCycleTime: number = 0;
                    _operation.potentialPCS = groupedOperations[operationName][0].pcs
                    for (const operation of groupedOperations[operationName]) {

                        if (operation.isCancelled === false) {
                            _operation.totalStudyPCS += 1
                            _operation.rawTotalProductiveTime += operation.cycleTime
                            validCycleTimes.push(operation.cycleTime)
                        }
                        if (operation.isBestCycle === true) {
                            // calculate bestCT
                            _operation.bestCT = operation.bestCT
                            _operation.ssv += operation.ssv
                            // calculate performance
                            _operation.performance = operation.performance
                            // calculate op group level additionalActivityTimes sum
                            for (const aat of operation.additionalActivityTimes) {
                                opAdditionalActivityTimesSum += aat.time
                            }
                        }
                        if (operation.isFlagged === true && operation.isCancelled === true) {
                            _operation.rawTotalNonProductiveTime += operation.cycleTime
                            if (_operation.nonProductiveAnalysis.labels.indexOf("OTHER") == -1) {
                                _operation.nonProductiveAnalysis.labels.push("OTHER")
                            }
                            npOtherCycleTime += Number((operation.cycleTime / 1000).toFixed(1))
                        }

                        for (const npt of operation.nonProductiveTimes) {
                            rawNonProductiveTimes.push(npt)
                        }
                    }
                    if (_operation.nonProductiveAnalysis.labels.indexOf("OTHER") != -1)
                        _operation.nonProductiveAnalysis.series.push(npOtherCycleTime)

                    const groupedNpt = utilFunctions.groupArray(rawNonProductiveTimes, 'typeName')
                    const nonProductiveTimes = []
                    for (const nptTypeName in groupedNpt) {
                        const nptTIme = {
                            time: 0,
                            timeId: -1,
                            typeId: -1,
                            typeName: nptTypeName
                        }
                        for (const npt of groupedNpt[nptTypeName]) {
                            nptTIme.time += npt.time
                            nptTIme.timeId = npt.timeId
                            nptTIme.typeId = npt.typeId
                            _operation.rawTotalNonProductiveTime += npt.time
                        }
                        nonProductiveTimes.push(nptTIme)
                    }

                    for (const npt of nonProductiveTimes) {
                        _operation.nonProductiveAnalysis.labels.push(npt.typeName)
                        _operation.nonProductiveAnalysis.series.push(+(npt.time / 1000).toFixed(1))
                    }

                    // add teas & tebs to non productive times if isMultipleOperation=false
                    if (!res.studyDetail.isMultipleOperation) {
                        if (res.studyDetail.tebsTime > 0) {
                            _operation.rawTotalNonProductiveTime += res.studyDetail.tebsTime
                            _operation.nonProductiveAnalysis.labels.push("TEBS")
                            _operation.nonProductiveAnalysis.series.push(+(res.studyDetail.tebsTime / 1000).toFixed(1))
                        }

                        if (res.studyDetail.teasTime > 0) {
                            _operation.rawTotalNonProductiveTime += res.studyDetail.teasTime
                            _operation.nonProductiveAnalysis.labels.push("TEAS")
                            _operation.nonProductiveAnalysis.series.push(+(res.studyDetail.teasTime / 1000).toFixed(1))
                        }
                    }

                    // set fastest CT
                    if (validCycleTimes.length > 0) {
                        const fastestCt = Math.min(...validCycleTimes) + opAdditionalActivityTimesSum
                        opFactestCtList.push(fastestCt);
                        _operation.fastestCT = fastestCt;
                    }

                    // add allAdditionalActivityTimes sum to rawTotalProductiveTime
                    _operation.rawTotalProductiveTime += opAdditionalActivityTimesSum
                    _operation.rawTotalElapsedTime = _operation.rawTotalNonProductiveTime + _operation.rawTotalProductiveTime
                    // convert units
                    const [nonProductiveTimeMin, nonProductiveTimeSec] = utilFunctions.millisecondsToMinAndSec(_operation.rawTotalNonProductiveTime)
                    const [productiveTimeMin, productiveTimeSec] = utilFunctions.millisecondsToMinAndSec(_operation.rawTotalProductiveTime)
                    const [totalElapsedTimeMin, totalElapsedTimeSec] = utilFunctions.millisecondsToMinAndSec(_operation.rawTotalElapsedTime)

                    _operation.watchError = (_operation.rawTotalElapsedTime - (_operation.rawTotalNonProductiveTime + _operation.rawTotalProductiveTime)) * 100
                    _operation.totalTimeAnalysis.series.push(+(_operation.rawTotalProductiveTime / 1000).toFixed(1), +(_operation.rawTotalNonProductiveTime / 1000).toFixed(1))
                    _operation.totalTimeAnalysis.labels.push('Productive Time', 'Non Productive Time')

                    _operation.potentialVsActual = Math.floor(_operation.totalStudyPCS / ((_operation.rawTotalElapsedTime / 1000) / _operation.bestCT) * 100)

                    _operation.fastestCT = _operation.fastestCT !== 0 ? +(_operation.fastestCT / 1000).toFixed(1) : 0
                    _operation.totalNonProductiveTime.min = nonProductiveTimeMin;
                    _operation.totalNonProductiveTime.sec = nonProductiveTimeSec;
                    _operation.totalProductiveTime.min = productiveTimeMin;
                    _operation.totalProductiveTime.sec = productiveTimeSec;
                    _operation.totalElapsedTime.min = totalElapsedTimeMin;
                    _operation.totalElapsedTime.sec = totalElapsedTimeSec;
                    _operation.performance = Math.floor(_operation.performance)

                    productionReportData.operations.push(_operation)
                }

                // generate summary data
                if (res.studyDetail.isMultipleOperation) {
                    let elapsesTimeByBestCtSum = 0;
                    for (const processedOperation of productionReportData.operations) {
                        productionReportData.summary.rawTotalProductiveTime += processedOperation.rawTotalProductiveTime
                        productionReportData.summary.rawTotalNonProductiveTime += processedOperation.rawTotalNonProductiveTime
                        productionReportData.summary.bestCT += processedOperation.bestCT
                        productionReportData.summary.ssv += processedOperation.ssv
                        productionReportData.summary.totalStudyPCS += processedOperation.totalStudyPCS
                        elapsesTimeByBestCtSum += (processedOperation.rawTotalElapsedTime / 1000) / processedOperation.bestCT
                    }
                    // calculate performance
                    productionReportData.summary.performance = Math.floor((productionReportData.summary.ssv / productionReportData.summary.bestCT) * 100)
                    // Add tebs & teas to total non productive time
                    productionReportData.summary.rawTotalNonProductiveTime += res.studyDetail.teasTime + res.studyDetail.tebsTime

                    productionReportData.summary.totalTimeAnalysis.series.push(
                        +(productionReportData.summary.rawTotalProductiveTime / 1000).toFixed(1),
                        +(productionReportData.summary.rawTotalNonProductiveTime / 1000).toFixed(1)
                    )
                    productionReportData.summary.totalTimeAnalysis.labels.push('Productive Time', 'Non Productive Time')
                    // non productive analysis
                    const nonProductiveTimes = [];
                    for (const operation of res.studyDetail.studyOperationTimes) {
                        for (const npt of operation.nonProductiveTimes) {
                            nonProductiveTimes.push(npt)
                        }
                    }
                    // add TEBS & TEAS to nonProductiveTimes
                    if (res.studyDetail.tebsTime > 0) {
                        nonProductiveTimes.push({
                            time: res.studyDetail.tebsTime,
                            timeId: -1,
                            typeId: -1,
                            typeName: "TEBS"
                        })
                    }

                    if (res.studyDetail.teasTime > 0) {
                        nonProductiveTimes.push({
                            time: res.studyDetail.teasTime,
                            timeId: -2,
                            typeId: -2,
                            typeName: "TEAS"
                        })
                    }
                    const groupedNpt = utilFunctions.groupArray(nonProductiveTimes, 'typeName')
                    for (const nptTypeName in groupedNpt) {
                        const nptTIme = {
                            time: 0,
                            typeName: nptTypeName
                        }
                        for (const npt of groupedNpt[nptTypeName]) {
                            nptTIme.time += npt.time
                        }
                        productionReportData.summary.nonProductiveAnalysis.series.push(+(nptTIme.time / 1000).toFixed(1))
                        productionReportData.summary.nonProductiveAnalysis.labels.push(nptTIme.typeName)
                    }
                    // set summary fastest ct
                    // get sum of each op fastest CT
                    if (opFactestCtList.length > 0) {
                        productionReportData.summary.fastestCT = +(opFactestCtList.reduce((a, b) => a + b, 0) / 1000).toFixed(1)
                    }

                    // convert units
                    productionReportData.summary.potentialVsActual = Math.floor((productionReportData.summary.totalStudyPCS / elapsesTimeByBestCtSum) * 100)

                    const [nonProductiveTimeMin, nonProductiveTimeSec] = utilFunctions.millisecondsToMinAndSec(productionReportData.summary.rawTotalNonProductiveTime)
                    const [productiveTimeMin, productiveTimeSec] = utilFunctions.millisecondsToMinAndSec(productionReportData.summary.rawTotalProductiveTime)
                    const [totalElapsedTimeMin, totalElapsedTimeSec] = utilFunctions.millisecondsToMinAndSec(res.studyDetail.elapsedTime)

                    productionReportData.summary.totalNonProductiveTime.min = nonProductiveTimeMin
                    productionReportData.summary.totalNonProductiveTime.sec = nonProductiveTimeSec
                    productionReportData.summary.totalProductiveTime.sec = productiveTimeSec
                    productionReportData.summary.totalProductiveTime.min = productiveTimeMin
                    productionReportData.summary.totalElapsedTime.min = totalElapsedTimeMin
                    productionReportData.summary.totalElapsedTime.sec = totalElapsedTimeSec
                    productionReportData.summary.bestCT = +(productionReportData.summary.bestCT).toFixed(1)
                }
                // Bind data
                setStudyBrowserPageState({
                    ...studyBrowserPageState,
                    productionReportPopup: true,
                    productionReportPopupData: productionReportData
                });
            },
            (error) => {
                dispatch(alertActions.triggerAlert(true, error, 'error'))
            })
        )
    }

    const toggleProductionReportPopup = (status: boolean, data: any) => {

        setStudyBrowserPageState({
            ...studyBrowserPageState,
            productionReportPopup: status,
            productionReportPopupData: data
        });
    };

    const onTimeStudyReportView = (studyId: number) => {
        dispatch(studyBrowserActions.getStudyBrowserDetail(studyId,
            (res) => {
                // TODO: report data section should complete after API changes completed
                const timeStudyReportData = {
                    isMultiple: res.studyDetail.isMultipleOperation,
                    createdAt: utilFunctions.formatDateTime(res.createdAt),
                    epf: res.studyDetail.studyOperationTimes[0].epf,
                    tmName: res.studyDetail.studyOperationTimes[0].teamMemberName,
                    operation: res.studyDetail.studyOperationTimes[0].operationName,
                    // totalStudyPcs: res.studyDetail.potentialPC,
                    totalStudyPcs: 0,
                    gsdSmv: 0,
                    gds100Tgt: 0,
                    gds80Tgt: 0,
                    timeStudySmv: 0,
                    tgt100: 0,
                    gsdVsTimeStudy: 0,
                    totalElapsedTime: {
                        min: '0',
                        sec: '0'
                    },
                    barChartData: {
                        categories: [],
                        data: []
                    }
                }
                const cycleTime = res.studyDetail.studyOperationTimes.reduce((prev, cur) => {
                    return prev + cur.bestCT
                }, 0)

                const totalSSV = res.studyDetail.studyOperationTimes.reduce((prev, cur) => {
                    return prev + cur.ssv
                }, 0)
                timeStudyReportData.totalStudyPcs = Math.floor(3600 / cycleTime);

                // convert total elapsed time from milliseconds to minutes & seconds
                const [elapsedTimeMinutes, elapsedTimeSeconds] = utilFunctions.millisecondsToMinAndSec(res.studyDetail.elapsedTime)
                timeStudyReportData.totalElapsedTime.min = elapsedTimeMinutes;
                timeStudyReportData.totalElapsedTime.sec = elapsedTimeSeconds;


                const filteredStudyElementTimes = []
                let ssvSum = 0;
                // group studyOperationTimes by operationName
                const groupedOperations = utilFunctions.groupArray(res.studyDetail.studyOperationTimes, 'operationName')
                for (const studyOperationName in groupedOperations) {
                    for (const op of groupedOperations[`${studyOperationName}`]) {
                        for (const elementTime of op.studyElementTimes) {
                            if (elementTime.isBestCycle === true) {
                                elementTime[`formattedElementName`] = `${elementTime.elementName}~${studyOperationName}`
                                filteredStudyElementTimes.push(elementTime)
                            }
                        }
                    }
                    // get grouped studyOperationTimes [0] index SSV sum to calculate GSD SMV
                    ssvSum += groupedOperations[`${studyOperationName}`][0].ssv
                }
                // calculate  GSD SMV
                const gsdSmv = +(ssvSum / 60).toFixed(3)
                // calculate GSD 100% TGT
                const gds100Tgt = Math.floor(60 / gsdSmv)
                // calculate GSD 80% TGT
                const gds80Tgt = Math.floor(gds100Tgt * 0.8)
                // calculate time study smv
                const timeStudySmv = +(res.studyDetail.totalSMV / 60).toFixed(3)
                // calculate 100% TGT
                const tgt100 = totalSSV !== 0 ? Math.floor(3600 / totalSSV) : 0
                // calculate GSD vs Time Study
                const gsdVsTimeStudy = +((gsdSmv / timeStudySmv) * 100).toFixed(1)
                // bind data
                timeStudyReportData.gsdSmv = gsdSmv;
                timeStudyReportData.gds100Tgt = gds100Tgt;
                timeStudyReportData.gds80Tgt = gds80Tgt;
                timeStudyReportData.timeStudySmv = timeStudySmv;
                timeStudyReportData.tgt100 = tgt100;
                timeStudyReportData.gsdVsTimeStudy = gsdVsTimeStudy;
                //  calculate totalCycleTime
                const totalCycleTime = filteredStudyElementTimes.reduce((prev, cur) => {
                    return prev + cur.cycleTime
                }, 0)

                // generate work combination chart data
                for (const filteredStudyElement of filteredStudyElementTimes) {
                    const category = [];
                    category.push(filteredStudyElement.formattedElementName)
                    timeStudyReportData.barChartData.categories.push(category);
                    timeStudyReportData.barChartData.data.push(+(filteredStudyElement.cycleTime / totalCycleTime * 100).toFixed(1));
                }
                // Bind data
                setStudyBrowserPageState({
                    ...studyBrowserPageState,
                    timeStudyReportPopup: true,
                    timeStudyReportPopupData: timeStudyReportData
                });
            },
            (error) => {
                dispatch(alertActions.triggerAlert(true, error, 'error'))
            }
        ))
    }

    const toggleTimeStudyReportPopup = (status: boolean, data: any) => {
        setStudyBrowserPageState({
            ...studyBrowserPageState,
            timeStudyReportPopup: status,
            timeStudyReportPopupData: data
        });
    };

    const onReportExport = (studyId: number) => {
        dispatch(studyBrowserActions.downloadStudyReport(studyId, () => { },
            (error) => {
                dispatch(alertActions.triggerAlert(true, error, 'error'))
            }
        ))
    }

    const downloadYamazumiReport = (reportData) => {
        let sbuName = ''
        let plantName = ''
        const sbuIndex = sbuListState.data.map(sbu => sbu.sbuCode).indexOf(cachedStudyBrowserFilters.sbuCode.value)
        if (sbuIndex > -1) {
            sbuName = sbuListState.data[sbuIndex].sbuName
            const plantIndex = sbuListState.data[sbuIndex].plants.map(plant => plant.code).indexOf(cachedStudyBrowserFilters.plantCode.value)
            if (plantIndex > -1) {
                plantName = sbuListState.data[sbuIndex].plants[plantIndex].name
            }
        }

        const payload: DownloadStudyBrowserReport = {
            balancingLoss: reportData.balancingLoss.toString(),
            categories: reportData.categories,
            createdAt: reportData.createdAt,
            division: sbuName,
            efficiency: `${reportData.moduleEfficiency}%`,
            elementMode: reportData.isElementBased ? 'True' : 'False',
            module: reportData.module,
            operationImproved: reportData.noOfOperationImproved.toString(),
            operationMode: reportData.isMultipleOperation ? 'Multiple' : 'Single',
            pacemakerCT: `${reportData.phaseMakerCT} sec`,
            plant: plantName,
            potentialPCS: `${reportData.potentialPC} pcs`,
            series: reportData.datasets,
            style: reportData.style,
            tactTime: `${reportData.tactTime} sec`,
            title: 'Yamazumi Study Report',
            totalElapsedTime: `${reportData.totalElapsedTime.min}min ${reportData.totalElapsedTime.sec}sec`,
            totalSMV: reportData.totalSMV.toString(),
            totalStudy: `${reportData.categories.length} TM`,
            version: reportData.version,
            worksheetName: 'Yamazumi Study',
            pitchTimeValue: reportData.pitchTime,
            tactTimeValue: reportData.tactTime
        }
        dispatch(reportActions.downloadYamazumiReport(payload,
            () => { },
            (error) => {
                dispatch(alertActions.triggerAlert(true, error, 'error'))
            }
        ))
    }

    // handle pagination page change event
    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
    };

    // handle pagination rows per page dropdown change event
    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const onSelectBestCt = (value: string) => {
        // setSelectedBestCt(value)
        dispatch(studyBrowserActions.onChangeStudyListIsBestVideo(value))
    }

    const onToggleAddComment = (rowId: number, comment?: string,) => {
        if (comment) {
            onRowCommentChange(comment)
        } else {
            setRowComment(INITIAL_ROW_COMMENT)
        }

        setIsCommentingRow(rowId)
    }

    const onRowCommentChange = (value: string) => {
        setRowComment({
            ...rowComment,
            comment: {
                ...rowComment.comment,
                value: value,
                error: null
            }
        })
    }

    const onApplyComment = async (isBestVideo: boolean, studyOperationTimeId?: number) => {
        const [validatedData, isValid]: any = await utilFunctions.validateFormData(rowComment)
        const _validatedData = validatedData as StudyRowCommentFormDataDto
        setRowComment(validatedData)

        if (!studyOperationTimeId) {
            dispatch(alertActions.triggerAlert(true, 'Invalid study operation time Id', 'warning'))
        }

        if (isValid) {
            const params: AddStudyOperationCommentPayloadDto = {
                StudyOperationTimeId: studyOperationTimeId,
                IsBestVideo: isBestVideo,
                Comment: _validatedData.comment.value
            }
            dispatch(studyBrowserActions.addStudyOperationComment(params,
                () => {
                    setIsCommentingRow(null)
                    setRowComment(INITIAL_ROW_COMMENT)
                    fetchCachedStudyBrowserList()
                },
                (error) => {
                    dispatch(alertActions.triggerAlert(true, error, 'error'))
                }))

        }
    }

    const fetchCachedStudyBrowserList = () => {
        const params: StudyBrowserListFiltersParamsDto = {
            sbuCode: cachedStudyBrowserFilters.sbuCode.value,
            plantCode: cachedStudyBrowserFilters.plantCode.value,
            factoryCode: cachedStudyBrowserFilters.factoryCode.value,
            module: cachedStudyBrowserFilters.module.value,
            shiftCode: cachedStudyBrowserFilters.shiftCode.value,
            style: cachedStudyBrowserFilters.style.value,
            createdBy: cachedStudyBrowserFilters.userEmail.value,
            fromDate: null,
            toDate: null,
            studyName: cachedStudyBrowserFilters.studyName.value,
            version: cachedStudyBrowserFilters.version.value,
            gsdCode: cachedStudyBrowserFilters.gsdCode.value,
            isBestVideo: cachedStudyBrowserFilters.isBestVideo.value,
            operationMasterId: cachedStudyBrowserFilters.operationMasterId.value,
            operatorMasterId: cachedStudyBrowserFilters.operatorMasterId.value,
        }
        if (!!cachedStudyBrowserFilters.dateStart.value) {
            params[`fromDate`] = new Date(cachedStudyBrowserFilters.dateStart.value).toISOString()
        }
        if (!!cachedStudyBrowserFilters.dateEnd.value) {
            params[`toDate`] = new Date(cachedStudyBrowserFilters.dateEnd.value).toISOString()
        }

        dispatch(studyBrowserActions.getStudyBrowserList(params,
            () => { },
            (error) => {
                // trigger alert onError
                dispatch(alertActions.triggerAlert(true, error, 'error'))
            }))
    }

    return (
        <AppLayout>
            <AppPopup
                scroll={'paper'}
                maxWidth='lg'
                fullWidth={true}
                // fullScreen={true}
                open={studyBrowserPageState.potentialReportPopup}
                onClose={(status) => togglePotentialReportPopup(status, {})}
                title={"Potential Study Report"}>
                <PotentialStudyReport reportData={studyBrowserPageState.potentialReportPopupData} />
            </AppPopup>

            <AppPopup
                scroll={'paper'}
                maxWidth='lg'
                fullWidth={true}
                // fullScreen={true}
                open={studyBrowserPageState.yamazumiEbReportPopup}
                onClose={(status) => toggleYamazumiEbReportPopup(status, {})}
                title={"Yamazumi Study Report"}>
                <YamazumiEbReport
                    onDownloadReport={downloadYamazumiReport}
                    reportData={studyBrowserPageState.yamazumiEbReportPopupData} />
            </AppPopup>

            <AppPopup
                scroll={'paper'}
                maxWidth='lg'
                fullWidth={true}
                // fullScreen={true}
                open={studyBrowserPageState.yamazumiNebReportPopup}
                onClose={(status) => toggleYamazumiNebReportPopup(status, {})}
                title={"Yamazumi Study Report"}>
                <YamazumiNebReport
                    onDownloadReport={downloadYamazumiReport}
                    reportData={studyBrowserPageState.yamazumiNebReportPopupData} />
            </AppPopup>

            <AppPopup
                scroll={'paper'}
                maxWidth='lg'
                fullWidth={true}
                // fullScreen={true}
                open={studyBrowserPageState.productionReportPopup}
                onClose={(status) => toggleProductionReportPopup(status, {})}
                title={"Production Study Report"}>
                <ProductionStudyReport reportData={studyBrowserPageState.productionReportPopupData} />
            </AppPopup>

            <AppPopup
                scroll={'paper'}
                maxWidth='lg'
                fullWidth={true}
                // fullScreen={true}
                open={studyBrowserPageState.timeStudyReportPopup}
                onClose={(status) => toggleTimeStudyReportPopup(status, {})}
                title={"Time Study Report"}>
                <TimeStudyReport reportData={studyBrowserPageState.timeStudyReportPopupData} />
            </AppPopup>

            <AppPopup
                scroll={'paper'}
                open={studyBrowserPageState.studyDetailPopup}
                onClose={(status) => toggleStudyDetailPopup(status, [])}
                maxWidth='sm'
                fullWidth={true}
                title={"Study Detail"}>
                <StudyBrowserDetail data={studyBrowserPageState.studyDetailPopupData} />
            </AppPopup>

            <AppPopup
                scroll={'paper'}
                open={studyBrowserPageState.aatDetailPopup}
                onClose={(status) => toggleAatDetailPopup(status, [])}
                maxWidth='sm'
                fullWidth={true}
                title={"Additional Activity Time Detail"}>
                <StudyBrowserAatDetail data={studyBrowserPageState.aatDetailPopupData} />
            </AppPopup>

            <AppPopup
                title={"Study Video"}
                open={studyBrowserPageState.videoPopup}
                maxWidth='sm'
                fullWidth={true}
                onClose={(status) => toggleVideoPopup(status, '')}>
                <AzureMediaPlayer
                    width="560"
                    height="360"
                    videoUrl={studyBrowserPageState.videoPopupUrl} />
            </AppPopup>

            <Grid container className={'appPageHeader'}>
                <Grid container item xs={12} sm={12} md={7} lg={7} justify="flex-start" alignContent="center">
                    <span className={'pageTitle'}>Study <b>Browser</b></span>
                </Grid>
                <Grid container item xs={12} sm={12} md={5} lg={5} justify="flex-end" alignContent="center">

                </Grid>
            </Grid>

            <div className="appPageContent">
                <StudyBrowserFilters
                    onFilterClear={onFilterClear}
                    onFilterChange={onFilterChange}
                    onFilterSearchTermChange={onFilterSearchTermChange}
                    onFilterApply={onFilterApply}
                    filteredUsers={filteredUsers}
                    filteredOperationMasters={filteredOperaionMasters}
                    filteredOperatorMasters={filteredOperatorMasters}
                    filterData={studyBrowserFilters}
                    filteredFactories={filteredFactories}
                    filteredPlants={filteredPlants}
                    sbus={sbuListState.data}
                    shifts={shiftListState.data} />
                <StudyBrowserList
                    onStudyDetailView={onStudyDetailView}
                    onPotentialReportView={onPotentialReportView}
                    onYamazumiEbReportView={onYamazumiEbReportView}
                    onYamazumiNebReportView={onYamazumiNebReportView}
                    onProductionReportView={onProductionReportView}
                    onTimeStudyReportView={onTimeStudyReportView}
                    onVideoView={onVideoView}
                    onReportExport={onReportExport}
                    data={studyBrowserListState.data}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    isGsdCodeApplied={!!cachedStudyBrowserFilters.gsdCode.value}
                    isWebview={utilFunctions.isWebView(navigator.userAgent, APP_CONFIGS.TULITA_APP_USER_AGENT)}
                    onAdditionalActivityView={onAdditionalActivityView}
                    isCommentingRow={isCommentingRow}
                    onApplyComment={onApplyComment}
                    onIsCommentingRowChange={(value) => setIsCommentingRow(value)}
                    onSelectBestCt={onSelectBestCt}
                    onToggleAddComment={onToggleAddComment}
                    rowComment={rowComment}
                    onRowCommentChange={onRowCommentChange}
                    isLoading={studyBrowserListState.isLoading} />
                <TablePagination
                    rowsPerPageOptions={APP_TABLE_SETTINGS.DEFAULT_ROWS_PER_PAGE}
                    component="div"
                    count={studyBrowserListState.data.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onChangePage={handleChangePage}
                    onChangeRowsPerPage={handleChangeRowsPerPage}
                    ActionsComponent={TablePaginationActions}
                />
            </div>
        </AppLayout>
    )
}

export default StudyBrowserPage;
